<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps" />
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="name"
              v-model="department.name"
              value=""
              placeholder="Nome"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Novo Departamento",
          routerName: "RegisterDepartment",
        },
      ],
      department: {
        name: "",
      },
      departmentParams: this.$route.params,
      dataProps: { module: "Company" },
    };
  },
  computed: {
    ...mapGetters({
      user: "User/user",
      departmentsData: "Company/departments",
    }),
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions("Company", [
      "registerDepartments",
      "consultDepartments",
      "setDataDefault",
    ]),
    async handleSubmit() {
      let message = this.department?.id
        ? "Departamento editado com sucesso!"
        : "Departamento cadastrado com sucesso!";

      await this.registerDepartments(this.department);
      this.$router.push({ name: "ListDepartments" });
      this.$swal.fire({
        icon: "success",
        html: message,
      });
    },
  },
  async mounted() {
    if (
      this.departmentParams &&
      Object.keys(this.departmentParams).length > 0
    ) {
      await this.consultDepartments(this.departmentParams);
      this.dataProps = {
        name: this.departmentsData.name,
        id: this.departmentParams.id,
        module: "Company",
        type: "Department",
      };
      this.department = this.departmentsData;
      this.links[1].name = this.department.name;
    }
  },
};
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px) {
    margin-top: 50px;
  }
}
</style>
